import { render, staticRenderFns } from "./GamesBlockWithBigLeftItem.vue?vue&type=template&id=3fca790c&scoped=true&"
import script from "./GamesBlockWithBigLeftItem.vue?vue&type=script&lang=js&"
export * from "./GamesBlockWithBigLeftItem.vue?vue&type=script&lang=js&"
import style0 from "./GamesBlockWithBigLeftItem.vue?vue&type=style&index=0&id=3fca790c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fca790c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fca790c')) {
      api.createRecord('3fca790c', component.options)
    } else {
      api.reload('3fca790c', component.options)
    }
    module.hot.accept("./GamesBlockWithBigLeftItem.vue?vue&type=template&id=3fca790c&scoped=true&", function () {
      api.rerender('3fca790c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/games/GamesBlockWithBigLeftItem.vue"
export default component.exports